<!--
  Esta es la plantilla que se usa para las páginas que pertenecen al panel
-->
<template>
  <v-main v-if="$store.operador.atributosRol" class="fondo-app">

    <!-- menu lateral / drawer -->

    <v-navigation-drawer v-model="menuLateral" fixed app >
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="@/assets/avatar.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{$store.operador.nombre}}</v-list-item-title>
          <v-list-item-subtitle>{{$store.operador.rol}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <span v-for="(elemento, i) in elementosMenuOperador" :key="elemento.titulo">
          <v-divider v-if="i>0 && elementosMenuOperador[i-1].seccion != elementosMenuOperador[i].seccion" class="my-2" />

          <v-list-group v-if="elemento.menu">
            <template v-slot:activator>
              <v-list-item-icon class="mr-3">
                <v-icon>{{ elemento.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ elemento.titulo }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <span v-for="(subelemento, j) in elemento.elementos" :key="subelemento.titulo">
              <v-divider v-if="j>0 && elemento.elementos[j-1].seccion != elemento.elementos[j].seccion" class="my-2" />

              <v-list-item link :to="subelemento.ruta" class="ml-4">
                <v-list-item-icon class="mr-3">
                  <v-icon>{{ subelemento.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ subelemento.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span>
          </v-list-group>

          <v-list-item v-else link :to="elemento.ruta">
            <v-list-item-icon class="mr-3">
              <v-icon>{{ elemento.icono }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-badge
                :content="elemento.notificaciones"
                :value="elemento.notificaciones > 0"
                inline>
                <v-list-item-title>{{ elemento.titulo }}</v-list-item-title>
              </v-badge>
            </v-list-item-content>
          </v-list-item>
        </span>
      </v-list>

      <div style="height: 30px"></div>
    </v-navigation-drawer>

    <!-- app bar -->
    <v-app-bar class="barras-app">
      <v-app-bar-nav-icon @click="menuLateral=!menuLateral"></v-app-bar-nav-icon>
      <!-- <img :src="$parametros_configuracion.rutassins + '/logo.png'" style="margin-top: 5px; margin-left: 5px; max-height: 40px" /> -->
      <div class="logo-cliente-barra-app" style="height: 40px"></div>

      <!-- <v-spacer></v-spacer> -->
      <div style="width: 1px; height: 50px; background-color: #999; margin-left: 3px; margin-right: 16px"></div>
      <v-toolbar-title>
        <router-link style="text-decoration: none; color: inherit" to="/panel">
           <div class="titulo-app mt-2">
            <!-- <img src="@/assets/autoriza.png" style="margin-right: 6px; max-height: 50px; vertical-align: middle; transform: translate(0, -4px);" /> -->

            <img v-if="$store.operador.empresaInquilina.urlLogo" :src="$store.operador.empresaInquilina.urlLogo" style="vertical-align: middle; width: auto; height: auto; max-width: 100%; max-height: 30px; margin-bottom: 8px"/>
            <span v-else-if="$store.operador.empresaInquilina.nombre" style="font-family: Monospace; color: #C62828; letter-spacing: -0.2px; font-size: 24px; font-weight: bold;">{{$store.operador.empresaInquilina.nombre}}</span>
            <span v-else style="font-family: Monospace; letter-spacing: -0.2px; font-size: 24px; font-weight: bold;">{{ env.VUE_APP_TITULO ? env.VUE_APP_TITULO : $parametros_configuracion.nomcomcli }}
              <span v-if="$parametros_configuracion.indinsdes" style="font-family: courier new; font-size: 16px; color: red">(dev)</span>
            </span>
          </div>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <template v-if="!$store.operador.id_ins && !$store.operador.empresaInquilina.nombre && arrayFiltroInstalaciones.length > 2">
        <v-select
          :items="arrayFiltroInstalaciones"
          item-text="nom"
          item-value="id_ins"
          v-model="$store.datos.id_instalacion_seleccionada"
          :class="[{ 'fondo-amarillo': $store.datos.id_instalacion_seleccionada }, 'select-instalacion-empresa']"
          prepend-inner-icon="mdi-file-powerpoint-box"
          hide-details
          dense
          @change="changeFiltroInstalacion">
        </v-select>
      </template>

      <template v-if="$parametros_configuracion.modempinq && !$store.operador.empresaInquilina.nombre">
        <v-select
          :items="arrayFiltroEmpresasInquilinas"
          item-text="nom"
          item-value="id_empinq"
          v-model="$store.datos.id_empresa_inquilina_seleccionada"
          :class="[{ 'fondo-amarillo': $store.datos.id_empresa_inquilina_seleccionada }, 'select-instalacion-empresa']"
          prepend-inner-icon="mdi-vector-square"
          hide-details
          dense
          @change="changeFiltroEmpresaInquilina">
        </v-select>
      </template>
      <!-- <div v-else v-show="$vuetify.breakpoint.mdAndUp && menuLateral" style="width: 16%; height: 5px;"></div> -->

      <template v-if="permitirConmutarModoPantalla">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="conmutarModoPantalla" v-bind="attrs" v-on="on">
              <v-icon v-if="!$global.enModoPantallaCompleta">mdi-fullscreen</v-icon>
              <v-icon v-else>mdi-fullscreen-exit</v-icon>
            </v-btn>
          </template>
          {{ $t ('Modo pantalla completa') }}
        </v-tooltip>
      </template>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon style="margin-right: 5px" v-bind="attrs" v-on="on" @click="cerrarSesion">
            <v-icon>mdi-logout-variant</v-icon>
          </v-btn>
        </template>
        {{ $t ('Cerrar sesión') }}
      </v-tooltip>
    </v-app-bar>

    <!-- notificaciones de interfonía -->
    <NotificacionesInterfonia @gestionar-notificacion="atenderNotificacionInterfonia" />

    <!-- {{$global.notificacionesIncidencias}} -->
    <!-- {{$global.ultimasIncidenciasAparatos}} -->

    <!-- router view -->

    <v-scroll-x-transition hide-on-leave>
      <router-view :key="claveRouterView" />
    </v-scroll-x-transition>

    <div style="height: 65px"></div>

    <!-- pie de la vista -->

    <v-footer absolute padless tile class="barras-app" style="opacity: 0.7">
      <v-container class="text-center pa-1">
        {{ new Date().getFullYear() }} —
        <strong>EQUINSA Parking</strong>
        <span class="caption"> - v{{version}}</span>
      </v-container>
    </v-footer>

  </v-main>
</template>

<script>
import menu from '@/menu.js';
import { DateTime } from "luxon";
import Vue from 'vue';
import api from "@/api"
import screenfull from 'screenfull';
import SAGAbroker from '@/sagabroker';
import NotificacionesInterfonia from '@/components/NotificacionesInterfonia.vue';

export default {
  components: { NotificacionesInterfonia },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    menuLateral: true,
    manejadorEscuchadorIncidencias: null,
    manejadorEscuchadorCambioEstadoAparcamientos: null,
    elementosMenuOperador: [],
    claveRouterView: 0,
  }),
  computed: {
    env () {
      return process.env;
    },
    arrayFiltroInstalaciones() {
      let array = this.$store.operador.instalaciones;
      //array = array.filter ((e) => !e.ocultar);
      array.sort ((a,b) => a.nom.localeCompare (b.nom));
      array.unshift ({id_ins: null, nom: this.$t ('(Vista global)') });
      return array;
    },
    arrayFiltroEmpresasInquilinas() {
      let array = (this.$tablasConsulta.arrayRegistros ('empinq') || []).filter ((e) => !e.ocultar);
      array.sort ((a,b) => a.nom.localeCompare (b.nom));
      array.push ({id_empinq: -1, nom: this.$t ('(Ninguna)') });
      array.unshift ({id_empinq: null, nom: this.$t ('(Todas las empresas)') });
      return array;
    },
    permitirConmutarModoPantalla() {
      return screenfull.isEnabled;
    }
  },
  methods: {
    changeFiltroInstalacion (){
      this.$store.datos.id_empresa_inquilina_seleccionada = null;
      api.guardarDatosSesion ( { id_instalacion_seleccionada: this.$store.datos.id_instalacion_seleccionada,
                                   id_empresa_inquilina_seleccionada: this.$store.datos.id_empresa_inquilina_seleccionada })
        .then (() => {
          this.$tablasConsulta.invalidar();
          this.$tablasConsulta.actualizar()
            .then  (() => {
              this.claveRouterView = Math.round (Math.random ()*99999);
            });
        });
    },
    changeFiltroEmpresaInquilina (){
      api.guardarDatosSesion ( { id_empresa_inquilina_seleccionada: this.$store.datos.id_empresa_inquilina_seleccionada })
        .then (() => {
          this.$tablasConsulta.invalidar();
          this.$tablasConsulta.actualizar()
            .then  (() => {
              this.claveRouterView = Math.round (Math.random ()*99999);
            });
        });
    },
    conmutarModoPantalla (){
      if (screenfull.isEnabled)
        screenfull.toggle();
    },
    cerrarSesion() {
      this.$store.CERRAR_SESION()
        .then (() => {
          window.location.replace(process.env.VUE_APP_URL_BASE_FRONTEND);
        });
    },
    atenderNotificacionInterfonia (notificacion) {
      api.interfonia ({ event: 'managed_call', call_id: notificacion.datos.id_registro_interfonia });
      this.$global.identificadorInterfoniaAGestionar = notificacion.datos.origen.id_dispositivo;
      if (this.$route.path != '/panel/asistenciaRemota')
        this.$router.push ( { path: '/panel/asistenciaRemota' } );
    },
    procesarIncidenciaSAGA(mensaje) {
      let datos_evento = mensaje.contenido.datos_evento;
      let codigo_aparato = String (datos_evento.id_instalacion).padStart (4, "0") + "." +
                           String (datos_evento.tipo_aparato).padStart (2, "0") + "." +
                           String (datos_evento.numero_aparato).padStart (2, "0");
      let descripcion_incidencia = this.$tablasConsulta.registroPorClave ('c_tipinc', mensaje.contenido.datos_evento.codigo_tipo_incidencia, 'des');
      // console.log (codigo_aparato, descripcion_incidencia);

      Vue.set (this.$global.ultimasIncidenciasAparatos, codigo_aparato, { descripcion: descripcion_incidencia, momento: DateTime.now().toISO() });
      setTimeout (() => {
        Vue.delete (this.$global.ultimasIncidenciasAparatos, codigo_aparato);
      }, 30000);
    },
    procesarCambioEstadoAparcamientosSAGA(mensaje){
      let datos_evento = mensaje.contenido.datos_evento;
      let objetoEstadoInstalacion = this.$global.estadoInstalaciones [datos_evento.id_instalacion];
      if (objetoEstadoInstalacion == undefined)
        objetoEstadoInstalacion = {};
      objetoEstadoInstalacion.id = datos_evento.id_instalacion;
      objetoEstadoInstalacion.zonas = {...datos_evento.zonas};
      objetoEstadoInstalacion.contadores = {...datos_evento.contadores};
      objetoEstadoInstalacion.carteles = {...datos_evento.carteles};
      Vue.set (this.$global.estadoInstalaciones, datos_evento.id_instalacion, objetoEstadoInstalacion);
    },
    procesarNotificacionesOperador(mensaje) {
      console.log ("procesarNotificacionesOperador", mensaje);
    }
  },
  created() {
    // traducimos las opciones del menú
    menu.aplicarTraducciones();

    // actualizamos las tablas de consulta
    this.$tablasConsulta.actualizar();

    // SAGABroker
    let idInstalacionSuscripciones = '*';
    if (this.$store.operador.idInstalacion)
      idInstalacionSuscripciones = this.$store.operador.idInstalacion;

    Vue.prototype.$sagabroker = new SAGAbroker (this.$parametros_configuracion.urlsagbro,
                                                'ARIS @ ' + this.$store.operador.correoElectronico,
                                                (sagabroker) => {
                                                  let suscripciones = ["$conexiones"];
                                                  if (this.$parametros_configuracion.modconrem && this.$store.operador.atributosRol.includes ('accsinapa'))
                                                    suscripciones.push (`aparcamiento/${idInstalacionSuscripciones}/eventos/*`);
                                                  if (this.$parametros_configuracion.modint && this.$store.operador.atributosRol.includes ('accsinapa') && this.$store.operador.atributosRol.includes ('recnotint'))
                                                    suscripciones.push ("central_interfonia/llamadas");
                                                  if (this.$parametros_configuracion.modinf)
                                                    suscripciones.push (`operador/${this.$store.operador.correoElectronico}/...`);

                                                  sagabroker.altaSuscripcionTemas (suscripciones);
                                                  //console.log("suscripciones SAGABroker", suscripciones);
                                                });

    //--- actualización de estado de aparatos ---
    this.$sagabroker.anadirEscuchadorTema (`aparcamiento/${idInstalacionSuscripciones}/sagacom/estados_aparatos`, (mensaje) => {
      if (mensaje.contenido.tipo_mensaje == "actualizacion_estado_aparatos") {
        let machines = mensaje.contenido.datos.machines;
        Object.keys (machines).forEach ((codigo_aparato) => {
          if (!this.$parametros_configuracion.perviaramconacc && machines [codigo_aparato].version.search ('RAMA ') > -1)
            return;
          machines [codigo_aparato].updated_at = new Date().toISOString();
          Vue.set (this.$global.estadoAparatos, codigo_aparato, machines [codigo_aparato]);
        });
      }
    });

    //--- gestion de eventos de conexion/desconexion ---
    this.$sagabroker.anadirEscuchadorTema ("$conexiones", (mensaje) => {
      if (mensaje.contenido.modulo == "SAGA - Plugin ARIS" &&
          mensaje.contenido.id_instalacion) {
        if (mensaje.cabecera.tipo == "NOTIFICACION_CONEXION") {
          // si estamos monitorizando el aparcamiento que se acaba de conectar, solicitamos una actualizacion de estado de aparatos
          if (this.$sagabroker.listaTemasEnEscucha().includes (`aparcamiento/${mensaje.contenido.id_instalacion}/eventos/*`)) {
            this.$sagabroker.solicitarActualizacionEstadoAparatos (mensaje.contenido.id_instalacion);
          }
        } else if (mensaje.cabecera.tipo == "NOTIFICACION_DESCONEXION") {
          let str_id_instalacion = String (mensaje.contenido.id_instalacion).padStart (4, "0");
          Object.keys (this.$global.estadoAparatos).forEach ((codigo_aparato) => {
            if (codigo_aparato.substr (0, 4) == str_id_instalacion)
              Vue.delete (this.$global.estadoAparatos, codigo_aparato);
          });
        }
      }
    });

    this.manejadorEscuchadorIncidencias = this.$sagabroker.anadirEscuchadorTema ("aparcamiento/*/eventos/inc", this.procesarIncidenciaSAGA);
    this.manejadorEscuchadorCambioEstadoAparcamientos = this.$sagabroker.anadirEscuchadorTema ("aparcamiento/*/eventos/camestapa", this.procesarCambioEstadoAparcamientosSAGA);
  },
  beforeMount () {
    this.elementosMenuOperador = menu.arbolOpcionesMenu();
  },
  destroyed() {
    this.$sagabroker.eliminarEscuchadorTema (this.manejadorEscuchadorCambioEstadoAparcamientos);
    this.$sagabroker.eliminarEscuchadorTema (this.manejadorEscuchadorIncidencias);
    this.$sagabroker.finalizar();
    Vue.prototype.$sagabroker = null;
  }
};
</script>

<style>
.destacar {
  color: aquamarine;
  font-size: 16px;
  font-weight: bold;
}
.select-instalacion-empresa {
  margin-left: 10px;
  padding: 4px !important;
  font-size: 14px;
  font-weight: 800;
  max-width: 250px;
}
.fondo-amarillo {
  background-color: #FFF59D;
}
</style>
